import { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import WarehouseService from "../../services/WarehouseService";

export default function WarehouseListPage() {
  const [warehouses, setWarehouses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadWarehouses();
  }, []);

  const loadWarehouses = async () => {
    setLoading(true);
    try {
      const res = await WarehouseService.getAll();
      if (res.success) {
        setWarehouses(res.data);
      }
    } catch (error) {
      console.error("Depolar yüklenirken hata oluştu:", error);
    } finally {
      setLoading(false);
    }
  };

  const actionTemplate = (rowData) => {
    return (
      <div className="flex gap-1 justify-center">
        <Button
          icon="pi pi-search"
          tooltip="Detay"
          className="p-button-rounded p-button-text text-blue-600"
          onClick={() => navigate(`/warehouses/detail/${rowData.id}`)}
        />
        <Button
          icon="pi pi-pencil"
          tooltip="Düzenle"
          className="p-button-rounded p-button-text text-amber-600"
          onClick={() => navigate(`/warehouses/edit/${rowData.id}`)}
        />
      </div>
    );
  };

  return (
    <div className="p-4">
      <div className="bg-white shadow-lg border border-slate-200 rounded-2xl p-5">
        <div className="flex flex-col md:flex-row items-center justify-between mb-6 gap-4">
          <div className="flex items-center gap-3">
            <div className="!bg-blue-600 p-3 rounded-xl shadow-md">
              <i className="pi pi-home text-white text-xl"></i>
            </div>
            <div>
              <h1 className="text-xl md:text-2xl font-black text-slate-900 uppercase tracking-tight">
                Depo Listesi
              </h1>
              <p className="text-slate-400 text-xs font-medium uppercase tracking-wider mt-0.5">
                Tanımlı depolar ve ürün miktarları
              </p>
            </div>
          </div>
          <Button
            label="YENİ DEPO EKLE"
            icon="pi pi-plus"
            className="!bg-blue-600 border-none rounded-xl px-6 py-3 font-black text-sm shadow-lg transition-all hover:scale-[1.02]"
            onClick={() => navigate("/warehouses/add")}
          />
        </div>

        <DataTable
          value={warehouses}
          loading={loading}
          className="p-datatable-sm cursor-pointer"
          responsiveLayout="scroll"
          emptyMessage="Henüz depo tanımlanmamış."
          onRowDoubleClick={(e) => navigate(`/warehouses/detail/${e.data.id}`)}
        >
          <Column field="name" header="Depo Adı" className="font-bold" />
          <Column field="address" header="Adres" />
          <Column
            field="totalProductQuantity"
            header="Toplam Ürün Miktarı"
            body={(row) => (
              <span className="font-black text-blue-600">
                {row.totalProductQuantity.toLocaleString("tr-TR")}
              </span>
            )}
            style={{ width: "200px" }}
          />
          <Column
            body={actionTemplate}
            style={{ width: "80px", textAlign: "center" }}
          />
        </DataTable>
      </div>
    </div>
  );
}
